export default __webpack_public_path__ + "dist/media/Deactivate.6cab40b6.svg";